import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'linaria';
import classnames from 'classnames';
import { headingSansSerif } from '@pocket/web-ui';
/**
 * Defaults to aligning child items to the right. Will likely contain button actions
 * but can be configured per instance
 */

const modalFooterStyles = "m11mcrga";
export const ModalFooter = ({
  children,
  hasBorder,
  isSticky,
  className
}) => {
  return <div className={classnames(modalFooterStyles, {
    bordered: hasBorder,
    sticky: isSticky
  }, className)}>
      {children}
    </div>;
};
ModalFooter.propTypes = {
  hasBorder: PropTypes.bool,
  isSticky: PropTypes.bool
};
ModalFooter.defaultProps = {
  hasBorder: true,
  isSticky: true
};
export default ModalFooter;

require("../../../.linaria-cache/src/components/modal/modal-footer.linaria.module.css");